import { useActionSheet as useExpoActionSheet } from "@expo/react-native-action-sheet";
import { Platform } from "react-native";
import { t } from "@/localization";

export const useActionSheet = () => {
  const { showActionSheetWithOptions: showNativeActionSheet } =
    useExpoActionSheet();

  const showActionSheetWithOptions = (options, callback) => {
    if (Platform.OS === "web") {
      // For web, use window.confirm with title and message
      let message = options.title || t("Are you sure?");
      if (options.message) {
        message = `${message}\n\n${options.message}`;
      }
      const result = window.confirm(message);

      // Call the callback with the appropriate index
      // 0 for confirm (first option), 1 for cancel (second option)
      callback(result ? 0 : 1);
    } else {
      // For native platforms, use the native action sheet
      showNativeActionSheet(options, callback);
    }
  };

  return { showActionSheetWithOptions };
};
